"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notNull = notNull;
exports.notUndefined = notUndefined;
exports.notNullOrUndefined = notNullOrUndefined;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports["default"] = void 0;

/**
 * @module       validation
 * @description  Helper functions for model field validation.
 *
 * @author  William Huster <william@thinknimble.com>
 */
var _default = {
  notNull: notNull,
  notUndefined: notUndefined,
  notNullOrUndefined: notNullOrUndefined,
  isArray: isArray,
  isFunction: isFunction
};
exports["default"] = _default;

function notNull(value) {
  return value != null;
}

function notUndefined(value) {
  return typeof value !== "undefined";
}

function notNullOrUndefined(value) {
  return notNull(value) && notUndefined(value);
}

function isArray(value) {
  return Array.isArray(value);
}

function isFunction(value) {
  return typeof value === "function";
}